export const NO_VALUE = '-';
export const ESTIMATE_VALUE = '≈';
